/*
 * @Author: 赵健
 * @Date: 2021-01-14 10:51:48
 * @LastEditTime: 2021-03-09 11:10:18
 * @LastEditors: 赵健
 * @Description: 修改描述
 * @FilePath: \Develop1.0.1\src\api\user.js
 */

import request from '@/utils/request'

export function login(data) {
  return request({
    // url: 'http://dev.qiye.yuanzhiyijiantong.com/porgan/g/user/login',
    url: '/api/merchant/login',
    method: 'post',
    data
  })
}

export function getInfo(data) {
  return request({
    url: '/api/merchant/login/info',
    method: 'post',
    data
  })
}

export function logout() {
  return request({
    url: '/api/merchant/logout',
    method: 'get'
  })
}

// 【会员中心- 商家管理】 商家修改密码
export function userUpdateUserPassword(data) {
  return request({
    url: '/api/merchant/resetPassword',
    method: 'post',
    data
  })
}
